import { State } from './types';

import actions from './authFeatureFlagsActions';

const initState: State = {
    requestState: 'uncalled',
    errorMessage: '',
    flags: {},
};

const authFeatureFlagsReducer = (state = initState, action) => {
    switch (action.type) {
        case actions.AUTH_FEATURE_FLAGS__REQUEST_START:
            return {
                ...state,
                requestState: action.payload.requestState,
                errorMessage: action.payload.errorMessage,
            };
        case actions.AUTH_FEATURE_FLAGS__REQUEST_SUCCESS:
            return {
                ...state,
                requestState: action.payload.requestState,
                flags: action.payload.flags,
            };
        case actions.AUTH_FEATURE_FLAGS__REQUEST_REJECT:
            return {
                ...state,
                requestState: action.payload.requestState,
                errorMessage: action.payload.errorMessage,
            };
        default:
            return state;
    }
};

export default authFeatureFlagsReducer;
